<script lang="typescript">
 import LensDetail from './LensDetail.svelte';
 import { variantImages } from '../appData.js';
    import { state } from "../stores.js";
    import { isChildrenLens } from "../utils.js";
</script>

<LensDetail title="Polarised" images="{variantImages.polarised}">
    <div><p>A sun lens that reduces glare, providing clearer vision in sunlight, offering UVA/UVB protection.</p></div>
    <div>
	<h2>The advantages of Polarised lenses are:</h2>
	<ol>
	    <li>Reduced glare – providing clearer vision in the sun</li>
	    <li>100% UVA/UVB protection - protecting your eyes from harmful UV rays</li>
	</ol>
    </div>
    <div>
	<h2>Who is it suitable for?</h2>
	<ul>
			{#if isChildrenLens($state)}
	    <li>Someone that spends lots of time outdoors or in contact with a reflective surface, e.g. water-sports, playing football or any other activities</li>
			{:else}
	    <li>Both adults and children</li>
	    <li>Someone that spends lots of time outdoors or in contact with a reflective surface, e.g. driving, fishing, water-sports etc</li>
	    <li>Occupations may include: driver, policeman, lifeguard or groundsman</li>
			{/if}
	</ul>
    </div>
</LensDetail>
